import { connect } from 'react-redux';
import actions from '../actions';
import ProjectPage from '../components/ProjectPage';

/*
  Map state and dispatch to component props
*/

const getProject = (state, ownProps) => {
  const { projects } = state;
  const { projectId } = ownProps.params;
  return projects[projectId];
};

const mapStateToProps = (state, ownProps) => ({
  project: getProject(state, ownProps),
  projects: state.projects,
  hasOpenModal: state.hasOpenModal
});

const mapDispatchToProps = dispatch => ({
  openModal: modalContent => {
    dispatch(
      actions.openModal(modalContent)
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectPage);



// WEBPACK FOOTER //
// ./src/containers/Project.js